import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { tap } from 'rxjs/operators';

import { IEnvironmentConfig } from '../interfaces/config.interface';
import { IIconDetails } from '../interfaces/icon-details.interface';

@Injectable()
export class AppConfigService {

  private appConfig: IEnvironmentConfig;

  constructor(private injector: Injector) { }

  get config(): IEnvironmentConfig {
    return this.appConfig;
  }

  loadAppConfig() {

    const http = this.injector.get(HttpClient);

    return http.get('assets/config/environment.json').pipe(
      tap(data => this.appConfig = data as IEnvironmentConfig)
    ).toPromise();
  }

  loadAppIcons() {

    const http = this.injector.get(HttpClient);
    const matIconRegistry = this.injector.get(MatIconRegistry);
    matIconRegistry.setDefaultFontSetClass('material-symbols-outlined', 'mat-ligature-font');
    const domSanitizer = this.injector.get(DomSanitizer);

    return http.get<IIconDetails[]>('assets/config/icons.json').pipe(
      tap(icons => {
        icons.map(icon => {
          matIconRegistry.addSvgIcon(
            icon.name,
            domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
          );
          });
        })
    ).toPromise();
  }
}
